//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useEffect, useState } from "react";

// Material ui Imports
import { SxProps } from "@mui/system";
import { CircularProgress, Grid, Typography, styled, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/SearchRounded";

// Custom components imports (and hooks and helpers)
import {
    formatDateTimePretty,
    VTButton,
    VTTextField,
    VTTypography,
    VTUserSelectTable,
} from "@virtus-tech-repository/virtus-tech-repository";

import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DateCalendar, DateField, LocalizationProvider } from "@mui/x-date-pickers";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { UserAttemptRowObjectType } from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
import { useGetScenarioAttemptsQuery, useGetUserAttemptsQuery } from "../../services/tracking.service";
import { Params, useParams } from "react-router-dom";
import { setSelectedAttempt } from "../../store/slices/current.slice";
import moment from "moment";
export const TemplateSceneImg = styled("img")(({ theme }) => ({
    borderRadius: "15px",
    height: "200px",
    width: "100%",
    objectFit: "cover",
    ":hover": {
        cursor: "pointer",
    },
}));

//---------------------------------------------------------------------------------------------------
// ## INTERFACES ##
interface IProps {
    sx?: SxProps;
}

export default function VTAttemptsSidePanel({ sx }: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##

    const dispatch = useAppDispatch();
    const theme = useTheme();

    const { currentSidePanel, selectedAttempt, selectedUser, selectedVersion } = useAppSelector(
        (state) => state.currentReducer,
    );
    const { scenarioId }: Readonly<Params<string>> = useParams();
    const [searchValue, setSearchValue] = useState<string>("");

    const [dateShow, setDateShow] = useState<boolean>(true);
    const [startDate, setStartDate] = useState<Dayjs>(dayjs("2022-04-17"));

    const [endDate, setEndDate] = useState<Dayjs>(dayjs("2022-04-17"));

    const { data: userAttempts } = useGetUserAttemptsQuery(
        selectedUser && selectedUser.id
            ? { scenarioId: selectedVersion ? selectedVersion : scenarioId, userId: selectedUser.id }
            : { scenarioId: "", userId: "" },
    );

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            sx={{
                height: "calc(100vh - 70px)",
                padding: "10px",
                width: "100%",
                paddingTop: "10px",
                overflow: "scroll",
                ...sx,
            }}
        >
            <Grid
                item
                xs={12}
                container
                justifyContent={"center"}
                alignContent={"flex-start"}
                // sx={{ height: "calc(100vh - 230px)", overflowY: "auto" }}
            >
                {userAttempts ? (
                    <VTUserSelectTable
                        // sx={{ marginInline: "5px" }}
                        tableData={[
                            ...userAttempts
                                .filter(
                                    (element: any) =>
                                        element.attemptId !== "undefined" &&
                                        element.data.date &&
                                        element.data.date.includes(searchValue),
                                )
                                .sort(
                                    (a: any, b: any) =>
                                        new Date(b.data.date).valueOf() - new Date(a.data.date).valueOf(),
                                )
                                .map((element: any) => {
                                    return {
                                        id: element.attemptId,
                                        name: element.data.date
                                            ? // `${element.data.date.split("T")[0]}  ${
                                              //       element.data.date.split("T")[1].split(".")[0]
                                              //   } `
                                              formatDateTimePretty(new Date(element.data.date))
                                            : "incomplete record",
                                    } as UserAttemptRowObjectType;
                                }),
                        ]}
                        onRowSelected={(e: any) => {
                            dispatch(
                                setSelectedAttempt(
                                    userAttempts.find((findElement: any) => findElement.attemptId === e.id)!,
                                ),
                            );
                        }}
                        selectedId={selectedAttempt ? [selectedAttempt.attemptId] : []}
                    />
                ) : (
                    <CircularProgress size={"4em"} sx={{ marginTop: "40px" }} />
                )}
            </Grid>
        </Grid>
    );
}
